import React from 'react';
import { Route, Switch } from 'react-router-dom';
import SaveProduct from '../../../ProductSave/index';

export default () => (
  <Switch>
    <Route exact path="/saveProduct" component={SaveProduct} />
  </Switch>
);
